import script from "./starRegion.vue?vue&type=script&setup=true&lang=js"
export * from "./starRegion.vue?vue&type=script&setup=true&lang=js"

import "./starRegion.vue?vue&type=style&index=0&id=214cbe8c&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-214cbe8c"]])

export default __exports__